module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-ir-library-a07bc137cd8b1ff21a5e0db4ec005d39.svg";